(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["omi-comfort-features"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('omi-pager')) {
    class OmiPager extends HTMLElement {
      connectedCallback() {
        this.items = [...this.querySelectorAll('.omi-pager__item')];
        this.count = this.querySelector('.omi-pager__count');
        this.buttons = [...this.querySelectorAll('.omi-pager__btn')];
        this.page = 0;
        this.mq = window.matchMedia('(min-width: 750px)');
        this.buttons.forEach((b) => b.addEventListener('click', () => this.go(this.page + Number(b.dataset.dir))));
        this.list = this.querySelector('.omi-pager__items');
        this.onChange = () => {
          this.measure();
          this.go(0);
        };
        this.mq.addEventListener('change', this.onChange);
        // Hold every page at the tallest page's height so the section doesn't jump while paging
        this.width = 0;
        this.resizer = new ResizeObserver(() => {
          if (this.offsetWidth === this.width) return;
          this.width = this.offsetWidth;
          this.measure();
        });
        this.resizer.observe(this);
        document.fonts?.ready.then(() => this.measure());
        this.go(0);
      }
      disconnectedCallback() {
        this.mq?.removeEventListener('change', this.onChange);
        this.resizer?.disconnect();
      }
      measure() {
        if (!this.list) return;
        const per = this.perPage;
        const pages = Math.max(1, Math.ceil(this.items.length / per));
        this.list.style.minHeight = '';
        let tallest = 0;
        for (let page = 0; page < pages; page++) {
          this.items.forEach((el, i) => {
            el.hidden = Math.floor(i / per) !== page;
          });
          tallest = Math.max(tallest, this.list.offsetHeight);
        }
        this.list.style.minHeight = `${tallest}px`;
        this.go(this.page);
      }
      get perPage() {
        return Number(this.mq.matches ? this.dataset.perPage : this.dataset.perPageMobile) || 1;
      }
      go(n) {
        const per = this.perPage;
        const pages = Math.max(1, Math.ceil(this.items.length / per));
        this.page = Math.max(0, Math.min(pages - 1, n));
        this.items.forEach((el, i) => {
          el.hidden = Math.floor(i / per) !== this.page;
        });
        if (this.buttons.length) {
          this.buttons[0].disabled = this.page === 0;
          this.buttons[1].disabled = this.page === pages - 1;
        }
        if (this.count) this.count.textContent = `${this.page + 1} / ${pages}`;
      }
    }
    customElements.define('omi-pager', OmiPager);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["omi-product-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('omi-carousel')) {
    class OmiCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.omi-carousel__track');
        this.slides = [...this.querySelectorAll('.omi-carousel__slide')];
        this.dots = this.querySelector('.omi-carousel__dots');
        this.prev = this.querySelector('[data-dir="-1"]');
        this.next = this.querySelector('[data-dir="1"]');
        this.prev?.addEventListener('click', () => this.go(this.page - 1));
        this.next?.addEventListener('click', () => this.go(this.page + 1));
        this.track.addEventListener('scroll', () => {
          cancelAnimationFrame(this.raf);
          this.raf = requestAnimationFrame(() => this.sync());
        }, { passive: true });
        this.ro = new ResizeObserver(() => this.build());
        this.ro.observe(this.track);
        this.build();
      }
      disconnectedCallback() {
        this.ro?.disconnect();
      }
      get per() {
        const v = getComputedStyle(this).getPropertyValue('--omi-per-now');
        return Math.max(1, Math.round(parseFloat(v)) || 1);
      }
      get pages() {
        return Math.max(1, Math.ceil(this.slides.length / this.per));
      }
      build() {
        const pages = this.pages;
        this.dots.innerHTML = '';
        this.dotEls = Array.from({ length: pages }, (_, i) => {
          const b = document.createElement('button');
          b.type = 'button';
          b.className = 'omi-carousel__dot';
          b.tabIndex = -1;
          b.addEventListener('click', () => this.go(i));
          this.dots.append(b);
          return b;
        });
        this.toggleAttribute('data-single', pages < 2);
        this.sync();
      }
      go(n) {
        const page = Math.max(0, Math.min(this.pages - 1, n));
        const target = this.slides[page * this.per];
        if (!target) return;
        this.track.scrollTo({ left: target.offsetLeft - this.track.offsetLeft, behavior: 'smooth' });
      }
      sync() {
        const w = this.slides[0]?.getBoundingClientRect().width || 1;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        const index = Math.round(this.track.scrollLeft / (w + gap));
        const atEnd = this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 4;
        this.page = atEnd ? this.pages - 1 : Math.floor(index / this.per);
        if (this.prev) this.prev.disabled = this.track.scrollLeft <= 4;
        if (this.next) this.next.disabled = atEnd;
        this.dotEls?.forEach((d, i) => d.toggleAttribute('data-active', i === this.page));
      }
    }
    customElements.define('omi-carousel', OmiCarousel);
  }

  } catch(e) { console.error(e); }
})();
})();
